import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class LoanPermissions extends BaseScenesPermissions {
    constructor({ 
        show = false, 
        enabled = false 
    } = {}) {
        super({ show, enabled })
    }
}

export default LoanPermissions
